import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';

import GenericLoader from '@joybird/joystagram-components/dist/esm/GenericLoader';
import ErrorFallbackPage from '@joybird/joystagram-components/dist/esm/ErrorFallbackPage';
import ConsumerHeader from '@joybird/joystagram-components/dist/esm/ConsumerHeader';
import { isClient } from '../../app/globals';
import routeService from './index';

const getInitialState = routeKey => {
  const route = routeService.routes.find(({ route }) => route === routeKey);
  if (route && !route.variants) {
    return false;
  }
  return true;
};

const LazyRoute = ({
  routeKey,
  serverQueryParams,
  childProps,
  serverRouteParams,
  hasDynamicVariants = false,
  routeDynamicVariantKeys = [],
}) => {
  const params = useParams();
  const [isRouteDataAvailable, setRouteDataAvailable] = useState(
    getInitialState(routeKey)
  );

  useEffect(() => {
    (async () => {
      if (!isRouteDataAvailable) {
        await routeService.fetchRoutesData();
        setRouteDataAvailable(true);
      }
    })();
  }, [isRouteDataAvailable]);

  if (isRouteDataAvailable) {
    const finalRouteParams = isClient() ? params : serverRouteParams;
    const Component = routeService.getComponentForRoute(
      routeKey,
      serverQueryParams,
      finalRouteParams,
      hasDynamicVariants,
      routeDynamicVariantKeys
    );
    return <Component {...childProps} />;
  }

  return (
    <ErrorFallbackPage>
      <ConsumerHeader />
      <GenericLoader />
    </ErrorFallbackPage>
  );
};

export default LazyRoute;
